"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erdstall__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_tee",
                type: "address",
            },
            {
                internalType: "uint64",
                name: "_epochDuration",
                type: "uint64",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "epoch",
                type: "uint64",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "token",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "value",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct Erdstall.TokenValue[]",
                name: "tokens",
                type: "tuple[]",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
        ],
        name: "ChallengeResponded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "epoch",
                type: "uint64",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Challenged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "epoch",
                type: "uint64",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "value",
                type: "bytes",
            },
        ],
        name: "Deposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "epoch",
                type: "uint64",
            },
        ],
        name: "Frozen",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "tokenType",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenHolder",
                type: "address",
            },
        ],
        name: "TokenRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "tokenType",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tokenHolder",
                type: "address",
            },
        ],
        name: "TokenTypeRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "epoch",
                type: "uint64",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "value",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "error",
                type: "bytes",
            },
        ],
        name: "WithdrawalException",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "epoch",
                type: "uint64",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "token",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "value",
                        type: "bytes",
                    },
                ],
                indexed: false,
                internalType: "struct Erdstall.TokenValue[]",
                name: "tokens",
                type: "tuple[]",
            },
        ],
        name: "Withdrawn",
        type: "event",
    },
    {
        inputs: [],
        name: "bigBang",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint64",
                        name: "epoch",
                        type: "uint64",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "exit",
                        type: "bool",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "bytes",
                                name: "value",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct Erdstall.TokenValue[]",
                        name: "tokens",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Erdstall.Balance",
                name: "balance",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
        ],
        name: "challenge",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "challengeDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "challenges",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "depositor",
                type: "address",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "value",
                type: "bytes",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "deposits",
        outputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "value",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint64",
                        name: "epoch",
                        type: "uint64",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "exit",
                        type: "bool",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "bytes",
                                name: "value",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct Erdstall.TokenValue[]",
                        name: "tokens",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Erdstall.Balance",
                name: "balance",
                type: "tuple",
            },
        ],
        name: "encodeBalanceProof",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ensureFrozen",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "epochDuration",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "frozenEpoch",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        name: "numChallenges",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "registerToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
            {
                internalType: "string",
                name: "tokenType",
                type: "string",
            },
        ],
        name: "registerTokenType",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint64",
                        name: "epoch",
                        type: "uint64",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "exit",
                        type: "bool",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "bytes",
                                name: "value",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct Erdstall.TokenValue[]",
                        name: "tokens",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Erdstall.Balance",
                name: "balance",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
        ],
        name: "respondChallenge",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tee",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tokenHolders",
        outputs: [
            {
                internalType: "contract TokenHolder",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tokenTypes",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint64",
                        name: "epoch",
                        type: "uint64",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "exit",
                        type: "bool",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "bytes",
                                name: "value",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct Erdstall.TokenValue[]",
                        name: "tokens",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Erdstall.Balance",
                name: "balance",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
        ],
        name: "verifyBalance",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint64",
                        name: "epoch",
                        type: "uint64",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "exit",
                        type: "bool",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "bytes",
                                name: "value",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct Erdstall.TokenValue[]",
                        name: "tokens",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Erdstall.Balance",
                name: "balance",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint64",
                        name: "epoch",
                        type: "uint64",
                    },
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bool",
                        name: "exit",
                        type: "bool",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "token",
                                type: "address",
                            },
                            {
                                internalType: "bytes",
                                name: "value",
                                type: "bytes",
                            },
                        ],
                        internalType: "struct Erdstall.TokenValue[]",
                        name: "tokens",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct Erdstall.Balance",
                name: "balance",
                type: "tuple",
            },
            {
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
        ],
        name: "withdrawFrozen",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawFrozenDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "withdrawn",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x60e0604052600780546001600160401b0319166002600160401b031790553480156200002a57600080fd5b5060405162003c9d38038062003c9d8339810160408190526200004d91620000de565b62000058336200008e565b6001600160601b031960609290921b919091166080526001600160c01b03194360c090811b821660a05291821b16905262000130565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b60008060408385031215620000f1578182fd5b82516001600160a01b038116811462000108578283fd5b60208401519092506001600160401b038116811462000125578182fd5b809150509250929050565b60805160601c60a05160c01c60c05160c01c613b1f6200017e600039600081816102b40152611d6f0152600081816101ad0152611d9301526000818161035201526113b80152613b1f6000f3fe608060405234801561001057600080fd5b50600436106101a35760003560e01c806367eeb62b116100ee578063abb3da1511610097578063ec7db36411610071578063ec7db3641461041c578063f29107731461042f578063f2fde38b1461045d578063f8d270fc1461047057600080fd5b8063abb3da15146103e3578063b1beaa29146103f6578063b39f252d1461040957600080fd5b80638da5cb5b116100c85780638da5cb5b14610384578063a33a0540146103a2578063aabc7fbb146103d057600080fd5b806367eeb62b1461034d578063715018a61461037457806384d984321461037c57600080fd5b80634739f7e511610150578063585db72a1161012a578063585db72a146102d6578063638b5e53146102ea57806364c38ddd1461034557600080fd5b80634739f7e51461027b5780634e9051341461028e5780634ff0876a146102af57600080fd5b8063234c49a011610181578063234c49a0146102175780632b55b4dc1461025557806346e6744b1461026857600080fd5b806303cf0678146101a85780630d13fd7b146101ed5780631003ac21146101f7575b600080fd5b6101cf7f000000000000000000000000000000000000000000000000000000000000000081565b60405167ffffffffffffffff90911681526020015b60405180910390f35b6101f5610483565b005b61020a6102053660046132c4565b6105a7565b6040516101e491906136c3565b61024561022536600461337a565b600560209081526000928352604080842090915290825290205460ff1681565b60405190151581526020016101e4565b6101f56102633660046131f9565b6105e8565b6101f561027636600461319d565b61080f565b6101f561028936600461316b565b610b56565b6102a161029c366004613395565b610bcb565b6040516101e4929190613538565b6101cf7f000000000000000000000000000000000000000000000000000000000000000081565b6007546101cf9067ffffffffffffffff1681565b6103206102f8366004613151565b60026020526000908152604090205473ffffffffffffffffffffffffffffffffffffffff1681565b60405173ffffffffffffffffffffffffffffffffffffffff90911681526020016101e4565b6101f5610cb7565b6103207f000000000000000000000000000000000000000000000000000000000000000081565b6101f5610e55565b6101f5610ec8565b60005473ffffffffffffffffffffffffffffffffffffffff16610320565b6102456103b036600461337a565b600460209081526000928352604080842090915290825290205460ff1681565b6101f56103de366004613264565b610f82565b6101f56103f1366004613264565b6110f1565b6101f56104043660046132ff565b6113a9565b61020a610417366004613151565b611428565b6101f561042a366004613264565b6114c2565b61044f61043d366004613360565b60066020526000908152604090205481565b6040519081526020016101e4565b6101f561046b366004613151565b611934565b6101f561047e366004613264565b611a2d565b6104a160075467ffffffffffffffff1667fffffffffffffffe141590565b156104f35760405162461bcd60e51b815260206004820152600f60248201527f4572647374616c6c2066726f7a656e000000000000000000000000000000000060448201526064015b60405180910390fd5b60006104fd611d6b565b905060038167ffffffffffffffff161061059a5767ffffffffffffffff7ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd8201166000908152600660205260409020541561059a5760405162461bcd60e51b815260206004820152601160248201527f4572647374616c6c20667265657a696e6700000000000000000000000000000060448201526064016104ea565b6105a46000611dc7565b50565b60603082600001518360200151846040015185606001516040516020016105d2959493929190613820565b6040516020818303038152906040529050919050565b60005473ffffffffffffffffffffffffffffffffffffffff16331461064f5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016104ea565b73ffffffffffffffffffffffffffffffffffffffff8316600090815260016020526040902061067d81611f7a565b61079c5761074a81805461069090613a49565b80601f01602080910402602001604051908101604052809291908181526020018280546106bc90613a49565b80156107095780601f106106de57610100808354040283529160200191610709565b820191906000526020600020905b8154815290600101906020018083116106ec57829003601f168201915b505050505084848080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250611f9092505050565b6107965760405162461bcd60e51b815260206004820152601e60248201527f7265676973746572656420746f6b656e2074797065206d69736d61746368000060448201526064016104ea565b50505050565b73ffffffffffffffffffffffffffffffffffffffff841660009081526001602052604090206107cc908484612d7c565b507f8a5b6f43357e19ca286ee63f93748e3699e6f0bc41d4d4d6c10dac15dc5edb89838386604051610800939291906136fb565b60405180910390a1505b505050565b33600090815260016020526040902061082790611f7a565b156108745760405162461bcd60e51b815260206004820152601760248201527f63616c6c6572206e6f7420746f6b656e20686f6c64657200000000000000000060448201526064016104ea565b61089260075467ffffffffffffffff1667fffffffffffffffe141590565b156108df5760405162461bcd60e51b815260206004820152600f60248201527f4572647374616c6c2066726f7a656e000000000000000000000000000000000060448201526064016104ea565b60006108e9611d6b565b905060038167ffffffffffffffff16106109865767ffffffffffffffff7ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd820116600090815260066020526040902054156109865760405162461bcd60e51b815260206004820152601160248201527f4572647374616c6c20667265657a696e6700000000000000000000000000000060448201526064016104ea565b6000610990611d6b565b905060028167ffffffffffffffff1610610a2d5767ffffffffffffffff7ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe82011660009081526006602052604090205415610a2d5760405162461bcd60e51b815260206004820152600f60248201527f6f70656e206368616c6c656e676573000000000000000000000000000000000060448201526064016104ea565b610a378433611fa5565b6000610a41611d6b565b67ffffffffffffffff8116600090815260036020908152604080832073ffffffffffffffffffffffffffffffffffffffff8b8116855290835281842082518084019093528a821683528284018a815281546001808201845592875295859020845160029097020180547fffffffffffffffffffffffff000000000000000000000000000000000000000016969093169590951782559351805195965091949093610af093908501920190612e1e565b5050508573ffffffffffffffffffffffffffffffffffffffff168167ffffffffffffffff167ff2699c019a825b01743e27e575d67b6715b1d4f3916879d6b877437838fa5c298787604051610b46929190613538565b60405180910390a3505050505050565b60005473ffffffffffffffffffffffffffffffffffffffff163314610bbd5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016104ea565b610bc78282611fa5565b5050565b60036020528260005260406000206020528160005260406000208181548110610bf357600080fd5b60009182526020909120600290910201805460018201805473ffffffffffffffffffffffffffffffffffffffff9092169550919350909150610c3490613a49565b80601f0160208091040260200160405190810160405280929190818152602001828054610c6090613a49565b8015610cad5780601f10610c8257610100808354040283529160200191610cad565b820191906000526020600020905b815481529060010190602001808311610c9057829003601f168201915b5050505050905082565b610cd560075467ffffffffffffffff1667fffffffffffffffe141590565b15610cdc57565b6000610ce6611d6b565b905060048167ffffffffffffffff161015610d695760405162461bcd60e51b815260206004820152602160248201527f746f6f206561726c792c206e6f20667265657a6520706f737369626c6520796560448201527f740000000000000000000000000000000000000000000000000000000000000060648201526084016104ea565b6000610d766003836139d2565b67ffffffffffffffff8116600090815260066020526040902054909150610ddf5760405162461bcd60e51b815260206004820152601260248201527f6e6f206f70656e206368616c6c656e676573000000000000000000000000000060448201526064016104ea565b6000610dec6001836139d2565b600780547fffffffffffffffffffffffffffffffffffffffffffffffff00000000000000001667ffffffffffffffff8316908117909155604051919250907f5e20151a99b0432a9ac06d33b91b77d3134ce0638cc70d7df042947ca48a2caf90600090a2505050565b60005473ffffffffffffffffffffffffffffffffffffffff163314610ebc5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016104ea565b610ec66000612058565b565b610ed0610cb7565b60408051600080825260208201909252610f189082610f12565b604080518082019091526000815260606020820152815260200190600190039081610eea5790505b506120cd565b90506000815111610f6b5760405162461bcd60e51b815260206004820152601160248201527f6e6f2066726f7a656e206465706f73697400000000000000000000000000000060448201526064016104ea565b6007546105a49067ffffffffffffffff16826124f8565b610f8a610cb7565b33610f9b6040850160208601613151565b73ffffffffffffffffffffffffffffffffffffffff1614610ffe5760405162461bcd60e51b815260206004820152601c60248201527f776974686472617746726f7a656e3a2077726f6e672073656e6465720000000060448201526064016104ea565b60075467ffffffffffffffff166110186020850185613360565b67ffffffffffffffff161461106f5760405162461bcd60e51b815260206004820152601b60248201527f776974686472617746726f7a656e3a2077726f6e672065706f6368000000000060448201526064016104ea565b6110b761107b84613a08565b83838080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152506113a992505050565b60006110d76110c960608601866138a6565b6110d2916139fb565b6120cd565b6007549091506107969067ffffffffffffffff16826124f8565b61110f60075467ffffffffffffffff1667fffffffffffffffe141590565b1561115c5760405162461bcd60e51b815260206004820152600f60248201527f4572647374616c6c2066726f7a656e000000000000000000000000000000000060448201526064016104ea565b6000611166611d6b565b905060038167ffffffffffffffff16106112035767ffffffffffffffff7ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd820116600090815260066020526040902054156112035760405162461bcd60e51b815260206004820152601160248201527f4572647374616c6c20667265657a696e6700000000000000000000000000000060448201526064016104ea565b336112146040860160208701613151565b73ffffffffffffffffffffffffffffffffffffffff16146112775760405162461bcd60e51b815260206004820152601760248201527f6368616c6c656e67653a2077726f6e672073656e64657200000000000000000060448201526064016104ea565b61127f6127ac565b67ffffffffffffffff166112966020860186613360565b67ffffffffffffffff16146112ed5760405162461bcd60e51b815260206004820152601660248201527f6368616c6c656e67653a2077726f6e672065706f63680000000000000000000060448201526064016104ea565b6112fd606085016040860161324a565b1561134a5760405162461bcd60e51b815260206004820152601560248201527f6368616c6c656e67653a20657869742070726f6f66000000000000000000000060448201526064016104ea565b61139261135685613a08565b84848080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152506113a992505050565b6107966113a260608601866138a6565b9050611dc7565b6113dc6113b5836105a7565b827f000000000000000000000000000000000000000000000000000000000000000061283b565b610bc75760405162461bcd60e51b815260206004820152601160248201527f696e76616c6964207369676e617475726500000000000000000000000000000060448201526064016104ea565b6001602052600090815260409020805461144190613a49565b80601f016020809104026020016040519081016040528092919081815260200182805461146d90613a49565b80156114ba5780601f1061148f576101008083540402835291602001916114ba565b820191906000526020600020905b81548152906001019060200180831161149d57829003601f168201915b505050505081565b6114e060075467ffffffffffffffff1667fffffffffffffffe141590565b1561152d5760405162461bcd60e51b815260206004820152600f60248201527f4572647374616c6c2066726f7a656e000000000000000000000000000000000060448201526064016104ea565b6000611537611d6b565b905060038167ffffffffffffffff16106115d45767ffffffffffffffff7ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd820116600090815260066020526040902054156115d45760405162461bcd60e51b815260206004820152601160248201527f4572647374616c6c20667265657a696e6700000000000000000000000000000060448201526064016104ea565b600060026115e0611d6b565b6115ea91906139d2565b905067ffffffffffffffff81166116046020870187613360565b67ffffffffffffffff1614806116435750611620816001613973565b67ffffffffffffffff166116376020870187613360565b67ffffffffffffffff16145b61168f5760405162461bcd60e51b815260206004820152601d60248201527f726573706f6e644368616c6c656e67653a2077726f6e672065706f636800000060448201526064016104ea565b61169f606086016040870161324a565b6116eb5760405162461bcd60e51b815260206004820152601f60248201527f726573706f6e644368616c6c656e67653a206e6f20657869742070726f6f660060448201526064016104ea565b6117336116f786613a08565b85858080601f0160208091040260200160405190810160405280939291908181526020018383808284376000920191909152506113a992505050565b67ffffffffffffffff81166000908152600560209081526040808320929161175f918901908901613151565b73ffffffffffffffffffffffffffffffffffffffff16815260208101919091526040016000205460ff166117fb5760405162461bcd60e51b815260206004820152602960248201527f726573706f6e644368616c6c656e67653a206e6f206368616c6c656e6765207260448201527f656769737465726564000000000000000000000000000000000000000000000060648201526084016104ea565b67ffffffffffffffff8116600090815260056020908152604080832091839161182991908a01908a01613151565b73ffffffffffffffffffffffffffffffffffffffff1681526020808201929092526040908101600090812080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00169415159490941790935567ffffffffffffffff84168352600690915281208054916118a283613a14565b909155506118b890506040860160208701613151565b73ffffffffffffffffffffffffffffffffffffffff166118db6020870187613360565b67ffffffffffffffff167f2af08918cce0ea11f75e2fd09224252af3bcf16ef6df3377daa6ca18fab82dbc61191360608901896138a6565b88886040516119259493929190613567565b60405180910390a35050505050565b60005473ffffffffffffffffffffffffffffffffffffffff16331461199b5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016104ea565b73ffffffffffffffffffffffffffffffffffffffff8116611a245760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f646472657373000000000000000000000000000000000000000000000000000060648201526084016104ea565b6105a481612058565b611a4b60075467ffffffffffffffff1667fffffffffffffffe141590565b15611a985760405162461bcd60e51b815260206004820152600f60248201527f4572647374616c6c2066726f7a656e000000000000000000000000000000000060448201526064016104ea565b6000611aa2611d6b565b905060038167ffffffffffffffff1610611b3f5767ffffffffffffffff7ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffd82011660009081526006602052604090205415611b3f5760405162461bcd60e51b815260206004820152601160248201527f4572647374616c6c20667265657a696e6700000000000000000000000000000060448201526064016104ea565b6000611b49611d6b565b905060028167ffffffffffffffff1610611be65767ffffffffffffffff7ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe82011660009081526006602052604090205415611be65760405162461bcd60e51b815260206004820152600f60248201527f6f70656e206368616c6c656e676573000000000000000000000000000000000060448201526064016104ea565b611bee6127ac565b67ffffffffffffffff16611c056020870187613360565b67ffffffffffffffff161115611c5d5760405162461bcd60e51b815260206004820152601360248201527f77697468647261773a20746f6f206561726c790000000000000000000000000060448201526064016104ea565b33611c6e6040870160208801613151565b73ffffffffffffffffffffffffffffffffffffffff1614611cd15760405162461bcd60e51b815260206004820152601660248201527f77697468647261773a2077726f6e672073656e6465720000000000000000000060448201526064016104ea565b611ce1606086016040870161324a565b611d2d5760405162461bcd60e51b815260206004820152601760248201527f77697468647261773a206e6f20657869742070726f6f6600000000000000000060448201526064016104ea565b611d396116f786613a08565b611d64611d496020870187613360565b611d5660608801886138a6565b611d5f916139fb565b6124f8565b5050505050565b60007f0000000000000000000000000000000000000000000000000000000000000000611db87f0000000000000000000000000000000000000000000000000000000000000000436139d2565b611dc2919061399f565b905090565b60006001611dd3611d6b565b611ddd91906139d2565b67ffffffffffffffff8116600090815260056020908152604080832033845290915290205490915060ff1615611e555760405162461bcd60e51b815260206004820152601260248201527f616c7265616479206368616c6c656e676564000000000000000000000000000060448201526064016104ea565b67ffffffffffffffff81166000908152600360209081526040808320338452909152812054611e84908461395b565b905060008111611ed65760405162461bcd60e51b815260206004820152601260248201527f6e6f2076616c756520696e2073797374656d000000000000000000000000000060448201526064016104ea565b67ffffffffffffffff82166000818152600560209081526040808320338452825280832080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0016600117905592825260069052908120805491611f3983613a84565b9091555050604051339067ffffffffffffffff8416907f9f71686e9e2eed0a0a99340b1c3b230369f255b1d452130cead54f8308654dfd90600090a3505050565b6000818054611f8890613a49565b159392505050565b6000611f9c83836128d1565b90505b92915050565b73ffffffffffffffffffffffffffffffffffffffff80831660009081526002602052604090205416801561204e578173ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff161461080a5760405162461bcd60e51b815260206004820152601a60248201527f7265676973746572656420686f6c646572206d69736d6174636800000000000060448201526064016104ea565b61080a83836128f6565b6000805473ffffffffffffffffffffffffffffffffffffffff8381167fffffffffffffffffffffffff0000000000000000000000000000000000000000831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b60075460609060009060039082906120f09067ffffffffffffffff166001613973565b67ffffffffffffffff908116825260208083019390935260409182016000908120338252909352908220600754909350600391839161213191166002613973565b67ffffffffffffffff168152602080820192909252604090810160009081203382529092528120805484548751929450909161216d919061395b565b612177919061395b565b67ffffffffffffffff81111561219d57634e487b7160e01b600052604160045260246000fd5b6040519080825280602002602001820160405280156121e357816020015b6040805180820190915260008152606060208201528152602001906001900390816121bb5790505b50905060005b85518110156122585785818151811061221257634e487b7160e01b600052603260045260246000fd5b602002602001015182828151811061223a57634e487b7160e01b600052603260045260246000fd5b6020026020010181905250808061225090613a84565b9150506121e9565b5060005b835481101561239d5783818154811061228557634e487b7160e01b600052603260045260246000fd5b600091825260209182902060408051808201909152600290920201805473ffffffffffffffffffffffffffffffffffffffff16825260018101805492939192918401916122d190613a49565b80601f01602080910402602001604051908101604052809291908181526020018280546122fd90613a49565b801561234a5780601f1061231f5761010080835404028352916020019161234a565b820191906000526020600020905b81548152906001019060200180831161232d57829003601f168201915b50505050508152505082875183612361919061395b565b8151811061237f57634e487b7160e01b600052603260045260246000fd5b6020026020010181905250808061239590613a84565b91505061225c565b5060005b82548110156124ef578281815481106123ca57634e487b7160e01b600052603260045260246000fd5b600091825260209182902060408051808201909152600290920201805473ffffffffffffffffffffffffffffffffffffffff168252600181018054929391929184019161241690613a49565b80601f016020809104026020016040519081016040528092919081815260200182805461244290613a49565b801561248f5780601f106124645761010080835404028352916020019161248f565b820191906000526020600020905b81548152906001019060200180831161247257829003601f168201915b505050919092525050855488518592506124a9908561395b565b6124b3919061395b565b815181106124d157634e487b7160e01b600052603260045260246000fd5b602002602001018190525080806124e790613a84565b9150506123a1565b50949350505050565b67ffffffffffffffff8216600090815260046020908152604080832033845290915290205460ff161561256d5760405162461bcd60e51b815260206004820152601160248201527f616c72656164792077697468647261776e00000000000000000000000000000060448201526064016104ea565b67ffffffffffffffff82166000908152600460209081526040808320338452909152812080547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff001660011790555b815181101561274e5760008282815181106125e657634e487b7160e01b600052603260045260246000fd5b6020026020010151905060006125ff8260000151612999565b825160208401516040517f9e625f6c00000000000000000000000000000000000000000000000000000000815292935073ffffffffffffffffffffffffffffffffffffffff841692639e625f6c9261265e9290913391906004016134ff565b600060405180830381600087803b15801561267857600080fd5b505af1925050508015612689575060015b612739573d8080156126b7576040519150601f19603f3d011682016040523d82523d6000602084013e6126bc565b606091505b50826000015173ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff168767ffffffffffffffff167f324e1c6519c5fc8e96d0272554c6897eeed2982ec44981f445288389080df55c86602001518560405161272f9291906136d6565b60405180910390a4505b5050808061274690613a84565b9150506125bb565b503373ffffffffffffffffffffffffffffffffffffffff168267ffffffffffffffff167fd6b76483eba16e2d86fcd5f7abf4192793840277a18766b5bc4762b4556938cf836040516127a091906136b0565b60405180910390a35050565b6000806127b7611d6b565b905060028167ffffffffffffffff1610156128145760405162461bcd60e51b815260206004820152601e60248201527f746f6f206561726c792c206e6f2065706f6368207365616c656420796574000060448201526064016104ea565b7ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe01919050565b60008061289c85805190602001206040517f19457468657265756d205369676e6564204d6573736167653a0a3332000000006020820152603c8101829052600090605c01604051602081830303815290604052805190602001209050919050565b905060006128aa8286612a10565b73ffffffffffffffffffffffffffffffffffffffff90811690851614925050509392505050565b600081518351148015611f9c5750508051602091820120825192909101919091201490565b600061290182612ab4565b73ffffffffffffffffffffffffffffffffffffffff8481166000818152600260205260409081902080547fffffffffffffffffffffffff000000000000000000000000000000000000000016938716939093179092559051919250907f75fc2d3ee17fe536c24f4c1b22222cfba758ec6c58730d76004dde33432496199061298c9084908690613735565b60405180910390a2505050565b73ffffffffffffffffffffffffffffffffffffffff80821660009081526002602052604081205490911680611f9f5760405162461bcd60e51b815260206004820152601460248201527f746f6b656e206e6f74207265676973746572656400000000000000000000000060448201526064016104ea565b6000815160411415612a445760208201516040830151606084015160001a612a3a86828585612b2f565b9350505050611f9f565b815160401415612a6c5760208201516040830151612a63858383612d39565b92505050611f9f565b60405162461bcd60e51b815260206004820152601f60248201527f45434453413a20696e76616c6964207369676e6174757265206c656e6774680060448201526064016104ea565b73ffffffffffffffffffffffffffffffffffffffff81166000908152600160205260408120612ae281611f7a565b15611f9f5760405162461bcd60e51b815260206004820152601b60248201527f746f6b656e20686f6c646572206e6f742072656769737465726564000000000060448201526064016104ea565b60007f7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0821115612bc75760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202773272076616c60448201527f756500000000000000000000000000000000000000000000000000000000000060648201526084016104ea565b8360ff16601b1480612bdc57508360ff16601c145b612c4e5760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202776272076616c60448201527f756500000000000000000000000000000000000000000000000000000000000060648201526084016104ea565b6040805160008082526020820180845288905260ff871692820192909252606081018590526080810184905260019060a0016020604051602081039080840390855afa158015612ca2573d6000803e3d6000fd5b50506040517fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0015191505073ffffffffffffffffffffffffffffffffffffffff8116612d305760405162461bcd60e51b815260206004820152601860248201527f45434453413a20696e76616c6964207369676e6174757265000000000000000060448201526064016104ea565b95945050505050565b60007f7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff821660ff83901c601b01612d7286828785612b2f565b9695505050505050565b828054612d8890613a49565b90600052602060002090601f016020900481019282612daa5760008555612e0e565b82601f10612de1578280017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00823516178555612e0e565b82800160010185558215612e0e579182015b82811115612e0e578235825591602001919060010190612df3565b50612e1a929150612e92565b5090565b828054612e2a90613a49565b90600052602060002090601f016020900481019282612e4c5760008555612e0e565b82601f10612e6557805160ff1916838001178555612e0e565b82800160010185558215612e0e579182015b82811115612e0e578251825591602001919060010190612e77565b5b80821115612e1a5760008155600101612e93565b600067ffffffffffffffff80841115612ec257612ec2613ad3565b8360051b6020612ed381830161390c565b868152935080840185838101891015612eeb57600080fd5b600093505b87841015612f7957803585811115612f0757600080fd5b87016040818b03811315612f1a57600080fd5b80518181018181108982111715612f3357612f33613ad3565b8252612f3e83612f85565b815285830135915087821115612f5357600080fd5b612f5f8c838501613005565b818701528452505060019390930192908201908201612ef0565b50505050509392505050565b803573ffffffffffffffffffffffffffffffffffffffff81168114612fa957600080fd5b919050565b80358015158114612fa957600080fd5b60008083601f840112612fcf578182fd5b50813567ffffffffffffffff811115612fe6578182fd5b602083019150836020828501011115612ffe57600080fd5b9250929050565b600082601f830112613015578081fd5b813567ffffffffffffffff81111561302f5761302f613ad3565b61306060207fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0601f8401160161390c565b818152846020838601011115613074578283fd5b816020850160208301379081016020019190915292915050565b60006080828403121561309f578081fd5b6040516080810167ffffffffffffffff82821081831117156130c3576130c3613ad3565b816040528293506130d385613139565b83526130e160208601612f85565b60208401526130f260408601612fae565b6040840152606085013591508082111561310b57600080fd5b508301601f8101851361311d57600080fd5b61312c85823560208401612ea7565b6060830152505092915050565b803567ffffffffffffffff81168114612fa957600080fd5b600060208284031215613162578081fd5b611f9c82612f85565b6000806040838503121561317d578081fd5b61318683612f85565b915061319460208401612f85565b90509250929050565b6000806000606084860312156131b1578081fd5b6131ba84612f85565b92506131c860208501612f85565b9150604084013567ffffffffffffffff8111156131e3578182fd5b6131ef86828701613005565b9150509250925092565b60008060006040848603121561320d578283fd5b61321684612f85565b9250602084013567ffffffffffffffff811115613231578283fd5b61323d86828701612fbe565b9497909650939450505050565b60006020828403121561325b578081fd5b611f9c82612fae565b600080600060408486031215613278578283fd5b833567ffffffffffffffff8082111561328f578485fd5b90850190608082880312156132a2578485fd5b909350602085013590808211156132b7578384fd5b5061323d86828701612fbe565b6000602082840312156132d5578081fd5b813567ffffffffffffffff8111156132eb578182fd5b6132f78482850161308e565b949350505050565b60008060408385031215613311578182fd5b823567ffffffffffffffff80821115613328578384fd5b6133348683870161308e565b93506020850135915080821115613349578283fd5b5061335685828601613005565b9150509250929050565b600060208284031215613371578081fd5b611f9c82613139565b6000806040838503121561338c578182fd5b61318683613139565b6000806000606084860312156133a9578081fd5b6133b284613139565b92506133c060208501612f85565b9150604084013590509250925092565b600081518084526020808501808196508360051b81019150828601855b858110156134415782840389528151805173ffffffffffffffffffffffffffffffffffffffff168552850151604086860181905261342d81870183613496565b9a87019a95505050908401906001016133ed565b5091979650505050505050565b81835281816020850137506000806020838501015260207fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0601f840116840101905092915050565b60008151808452815b818110156134bb5760208185018101518683018201520161349f565b818111156134cc5782602083870101525b50601f017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0169290920160200192915050565b600073ffffffffffffffffffffffffffffffffffffffff808616835280851660208401525060606040830152612d306060830184613496565b73ffffffffffffffffffffffffffffffffffffffff831681526040602082015260006132f76040830184613496565b60408082528181018590526000906060600587901b8401810190840188845b8981101561368e577fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffa087850301835281357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffc18c36030181126135e6578687fd5b8b0173ffffffffffffffffffffffffffffffffffffffff61360682612f85565b1685526020808201357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe183360301811261363e578889fd5b8201803567ffffffffffffffff81111561365657898afd5b80360384131561366457898afd5b88838901526136788989018285850161344e565b9750505093840193929092019150600101613586565b50505083810360208501526136a481868861344e565b98975050505050505050565b602081526000611f9c60208301846133d0565b602081526000611f9c6020830184613496565b6040815260006136e96040830185613496565b8281036020840152612d308185613496565b60408152600061370f60408301858761344e565b905073ffffffffffffffffffffffffffffffffffffffff83166020830152949350505050565b60408152600080845482600182811c91508083168061375557607f831692505b602080841082141561377557634e487b7160e01b87526022600452602487fd5b604088018490526060880182801561379457600181146137c3576137ed565b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff008716825282820197506137ed565b60008c815260209020895b878110156137e7578154848201529086019084016137ce565b83019850505b50508596506138138189018a73ffffffffffffffffffffffffffffffffffffffff169052565b5050505050509392505050565b60c08152600f60c08201527f4572647374616c6c42616c616e6365000000000000000000000000000000000060e0820152600061010073ffffffffffffffffffffffffffffffffffffffff808916602085015267ffffffffffffffff8816604085015280871660608501525084151560808401528060a08401526136a4818401856133d0565b60008083357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe18436030181126138da578283fd5b83018035915067ffffffffffffffff8211156138f4578283fd5b6020019150600581901b3603821315612ffe57600080fd5b604051601f82017fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe016810167ffffffffffffffff8111828210171561395357613953613ad3565b604052919050565b6000821982111561396e5761396e613abd565b500190565b600067ffffffffffffffff80831681851680830382111561399657613996613abd565b01949350505050565b600067ffffffffffffffff808416806139c657634e487b7160e01b83526012600452602483fd5b92169190910492915050565b600067ffffffffffffffff838116908316818110156139f3576139f3613abd565b039392505050565b6000611f9c368484612ea7565b6000611f9f368361308e565b600081613a2357613a23613abd565b507fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0190565b600181811c90821680613a5d57607f821691505b60208210811415613a7e57634e487b7160e01b600052602260045260246000fd5b50919050565b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff821415613ab657613ab6613abd565b5060010190565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052604160045260246000fdfea2646970667358221220b62cff4e6510a3c918075b0853e30258a3b6020ef5281612c07e095c049ca65764736f6c63430008040033";
class Erdstall__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(_tee, _epochDuration, overrides) {
        return super.deploy(_tee, _epochDuration, overrides || {});
    }
    getDeployTransaction(_tee, _epochDuration, overrides) {
        return super.getDeployTransaction(_tee, _epochDuration, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Erdstall__factory = Erdstall__factory;
Erdstall__factory.bytecode = _bytecode;
Erdstall__factory.abi = _abi;
//# sourceMappingURL=Erdstall__factory.js.map